import {
  IonContent,
  IonPage,
  useIonViewDidEnter,
  useIonViewWillLeave,
} from '@ionic/react';
import React, { useState } from 'react';
import useEnhancedAuth from '../EnhancedAuth';
import './Default.css';
import AppPageHeader from '../components/AppPageHeader';
import { useTranslation } from 'react-i18next';
import {
  apiAddVirtualFarecard,
  apiGetFareCards,
  apiGetFareCategories,
} from '../services/api';
import { strHasMaxLength } from '../utils/strings';
import {
  getAppError,
  getAppSuccess,
  getUserMessageOrValidationError,
} from '../utils/messages';
import AddVirtualFarecardForm from '../usecases/farecard/AddVirtualFarecardForm';
import { useHistory } from 'react-router';
import { storageSetCards } from '../utils/storage';
import { virtualCardCreated } from '../utils/nav';
import { LoadingController } from '../utils/LoadingController';
import { useToaster } from '../hooks/useToaster';

const CardsAddVirtualPage: React.FC = () => {
  const auth = useEnhancedAuth();
  const router = useHistory();
  const [t] = useTranslation('global');
  const [present] = useToaster();

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const [virtualName, setVirtualName] = useState<string>('');

  const [isPageActive, setIsPageActive] = useState(false);
  useIonViewDidEnter(() => {
    setIsPageActive(true);
  });
  useIonViewWillLeave(() => {
    setIsPageActive(false);
  });

  const getVirtualValidationError = () => {
    if (!strHasMaxLength(virtualName, 40)) {
      return t('farecards.errorname');
    }
    return false;
  };

  const addVirtualFinish = async () => {
    if (isSubmitting) {
      return;
    }
    const validationError = getVirtualValidationError();
    if (validationError !== false) {
      present(getAppError(validationError));
      return;
    }

    try {
      LoadingController.show();
      setIsSubmitting(true);
      const categories = await apiGetFareCategories();

      await apiAddVirtualFarecard(
        {
          fareCategoryId: categories.data[0].id,
          nickname: virtualName,
        },
        auth,
      );
      await apiGetFareCards(auth).then((response) => {
        storageSetCards(response.data);
      });
      present(getAppSuccess(t('farecards.virtualsuccess')));
      virtualCardCreated();
      router.push('/cards');
    } catch (error) {
      console.error('Error adding card ', error);
      const apiError = getUserMessageOrValidationError(error);
      if (typeof apiError === 'string') {
        present(getAppError(apiError));
      } else {
        present(getAppError(t('farecards.virtualnosuccess')));
      }
    } finally {
      LoadingController.hide();
      setIsSubmitting(false);
    }
  };

  return (
    <IonPage id="farecard-page">
      <>
        <AppPageHeader isPageActive={isPageActive}
          back={() => router.push('/cards')}
          title={t('farecards.createvirtual')}
        ></AppPageHeader>
        <IonContent fullscreen className="ion-padding default-content">
          <AddVirtualFarecardForm
            isValid={getVirtualValidationError() === false}
            name={virtualName}
            setName={setVirtualName}
            proceed={addVirtualFinish}
          />
        </IonContent>
      </>
    </IonPage>
  );
};

export default CardsAddVirtualPage;
